import * as React from "react";
import { Option } from "db";
import Switch from "components/switch/Switch";
import { styled } from "theme";
import Price from "components/Price";
import { Flex, IconButton } from "@chakra-ui/core";
import { useConfigurator } from "./Configurator";

export interface Props {
  option: Option;
  setOption: (b: boolean) => void;
}

export default function SingleOption({ option, setOption }: Props) {
  const { showOptionInfo } = useConfigurator();
  return (
    <Switch
      id={option.code + "tog"}
      isChecked={!!option.selected}
      isDisabled={!!option.fixed}
      onChange={(checked) => {
        setOption(checked);
      }}
    >
      <Flex alignItems="center">
        <Name
          onClick={() => {
            if (option.fixed !== true) {
              setOption(!option.selected);
            }
          }}
        >
          {option.name}
        </Name>

        <PriceContainer>{option.price && <Price active={!!option.selected} price={option.price} />}</PriceContainer>
        <InfoContainer>
          {option.description && (
            <IconButton
              variant="ghost"
              variantColor="teal"
              aria-label="info"
              icon="info"
              isRound={true}
              size="xs"
              onClick={() => {
                showOptionInfo(option);
              }}
            />
          )}
        </InfoContainer>
      </Flex>
    </Switch>
  );
}

const Name = styled.button`
  flex: 1 1 auto;
  border: 0;
  background-color: transparent;
  outline: 0;
  padding-right: 10px;
  text-align: left;
`;

const PriceContainer = styled.div`
  flex: 0 0 80px;
`;

const InfoContainer = styled.div`
  flex: 0 0 32px;
  display: flex;
  justify-content: flex-end;
`;
